module.exports = __webpack_public_path__ + "static/media/un_paso_mas.81ab6285.svg";